import React from "react";
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    EditButton,
    Loading,
    Filter,
    TextInput
} from "react-admin";

export const StoreFilter = props => (
    <Filter {...props}>
        <TextInput source="name" label="Name" defaultValue="" />
    </Filter>
);

const ParentCategoriesList = props => {
    const { permissions } = props;

    if (!permissions) return <Loading />;
    const permissionsList = permissions.split(",");

    console.log('>>>>>>>', props);
    return (
        <List {...props} exporter={false} bulkActionButtons={false} filters={<StoreFilter />}>
            <Datagrid rowClick={null}>
                <TextField source="name" label="Name" />
                <TextField source="sku_code" label="SKU Code" sortable={false} />
                <BooleanField source="active" label="Active" sortable={false} />
                {permissionsList.includes("edit_categories") && <EditButton />}
            </Datagrid>
        </List>
    );
};

export default ParentCategoriesList;